// useFitRecords.js
//
// Thin React binding for fitRecordStore.js — same shape as
// useFittingSession.js. Returns the current snapshot and re-renders the
// caller whenever the store changes.
import { useEffect, useState } from 'react';
import { getFitRecordState, subscribeFitRecords } from './fitRecordStore';

export function useFitRecords() {
  const [fitRecordState, setFitRecordState] = useState(getFitRecordState());
  useEffect(() => subscribeFitRecords(setFitRecordState), []);
  return fitRecordState;
}